import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ApiCallService } from "src/app/shared/services/dynamic-api-calling.service";
import { environment } from "src/environments/environment";
import { OfficerDashboardLinksComponent } from "../officer-dashboard-links/officer-dashboard-links.component";
import { Store } from "@ngrx/store";
import * as fromStore from "../../../store/index";
import { ToastrService } from "ngx-toastr";
import { Images } from "src/app/shared/config/images-config";
@Component({
  selector: "app-salary-slip",
  templateUrl: "./salary-slip.component.html",
  styleUrls: ["./salary-slip.component.scss"],
})
export class SalarySlipComponent implements OnInit {
  UserProfileDetails: any;
  selectedMonth: any;
  // selectedYear: number = 2023;
  selectedLanguage: any;
  currentYear: any = new Date().getFullYear();
  pdfUrl: string =
    "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";

  months: any = [
    { en: "January", mar: "जनवरी", value: 1 },
    { en: "February", mar: "फेब्रुवारी", value: 2 },
    { en: "March", mar: "मार्च", value: 3 },
    { en: "April", mar: "एप्रिल", value: 4 },
    { en: "May", mar: "मे", value: 5 },
    { en: "June", mar: "जून", value: 6 },
    { en: "July", mar: "जुलै", value: 7 },
    { en: "August", mar: "ऑगस्ट", value: 8 },
    { en: "September", mar: "सप्टेम्बर", value: 9 },
    { en: "October", mar: "ऑक्टोबर", value: 10 },
    { en: "November", mar: "नोव्हेम्बर", value: 11 },
    { en: "December", mar: "डिसेम्बर", value: 12 },
  ];
  lastSixMonths: any = [];
  images = Images;
  loader = false;
  downloadLoader = false
  color = "primary";
  mode = "indeterminate";
  value = 50;

  slips = [
    {
      month: "December",
      year: 2024,
      available: false,
      icon: Images.calendarPending,
    },
    {
      month: "November",
      year: 2024,
      available: true,
      icon: Images.calendarDownload,
    },
    {
      month: "October",
      year: 2024,
      available: true,
      icon: Images.calendarDownload,
    },
    {
      month: "September",
      year: 2024,
      available: true,
      icon: Images.calendarDownload,
    },
    {
      month: "August",
      year: 2024,
      available: true,
      icon: Images.calendarDownload,
    },
    {
      month: "July",
      year: 2024,
      available: true,
      icon: Images.calendarDownload,
    },
  ];
  labels: {};

  constructor(
    private apiCallService: ApiCallService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<OfficerDashboardLinksComponent>,
    private store: Store<fromStore.CEPState>,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.store.select(fromStore.getVerifyPasswordResponse).subscribe((data) => {
      if (data) {
        this.UserProfileDetails = data;
        this.getSalarySlipData();
      }
    });

    this.store.select(fromStore.getSalarySlipLabels).subscribe( (labels) => {
      this.labels = labels
    } )


    this.store.select(fromStore.getSelectedLanguage).subscribe((language) => {
      this.selectedLanguage = language;
    });
  }

  getSalarySlipData() {
    this.loader = true;
    this.apiCallService
      .apiCall(
        "post",
        environment.base_url + "/authenticationConfiguration/v1/salarySlippmc",
        {
          empCode: this.UserProfileDetails.empCode,
        }
      )
      .subscribe(
        (res: any) => {
          if (res.code === 200) {
            this.lastSixMonths = res.result;
            this.loader = false;
          } else {
            this.loader = false;
          }
        },
        (error: any) => {
          this.loader = false;
          console.log(error);
        }
      );
  }

  downloadSlip(slip: any) {
    this.downloadLoader = true
    if (slip.salarySlip.data) {
      const binaryString = atob(slip.salarySlip.data);

      // Create a byte array
      const byteNumbers = new Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        byteNumbers[i] = binaryString.charCodeAt(i);
      }

      // Create a Blob from the byte array
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.UserProfileDetails.empCode}-${slip.en}-${slip.year}`;

      // Trigger the download
      link.click();

      // Clean up
      window.URL.revokeObjectURL(link.href);
      link.remove();
      this.toastr.success(this.labels[this.selectedLanguage].PDFSaveSuccessfully)
      this.downloadLoader = false
    } else {
      this.toastr.error(this.labels[this.selectedLanguage].Nodatafound)
      this.downloadLoader = false
    }
  }

  closePopup() {
    this.dialogRef.close();
  }
}
